import { connect } from 'react-redux';
import { getCommentReactions } from '../../redux/selectors';
const mapStateToProps = (state, ownProps)=>({
        reactions: getCommentReactions(state, ownProps.comment)
    });
export default connect(mapStateToProps);
